import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { cmDeleteAnswer } from "../../../API/api";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";


const textStyles1 = {
   fontSize: "16px",
   color: "#2A364A",
   lineHeight: "24px",
   fontWeight: "500",
   wordBreak: 'break-word', overflowWrap: 'break-word',
   textAlign: "left",
   display:"flex",
   justifyContent:"center",
   width:"100%"


};
const modalTitleStyle = {
    color: "rgb(42, 54, 74)",
    fontSize: "20px",
    fontFamily: "Helvetica",
  };
export default function DeleteCmAnswer() {
   const [isLoading, isLoaded] = useState(false);
   const successMsg = (message) => {
       return (
           <>
               <span style={{ fontSize: "12px" }}>{message}</span>
           </>
       );
   };
   const modalState = useSelector((state) => state.domain);
   const expertRecordsState = useSelector((state) => state.expertRecord);
   const dispatch = useDispatch();
   const currentPath = useLocation();
   const navigate = useNavigate();
   const { advanceFilterModalToggle, cmrDetailedRefresh, cmrIsGoBack } = bindActionCreators(Actions, dispatch);
   const onClickButtons = () => {
       isLoaded(true);
       const payload = [{
           answerUuidStr: expertRecordsState.selectedDataDetailed.answerUuid
       }]


       cmDeleteAnswer(payload).then(res => {
           if (res === undefined) return;
           if (res.data.success) {
               cmrIsGoBack(false);
               toast.success(successMsg(res.data.message), {
                   position: toast.POSITION.TOP_RIGHT,
               });
               cmrDetailedRefresh('g')
               advanceFilterModalToggle({ bool: false, value: "" });
               isLoaded(false);
           }
       });
   }
  
   return (
       <Modal show={modalState.modalState}
           onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
           centered={true}
           size={"lg"}
           style={{ marginTop: "-50px" }}
       // scrollable={true}
       >
           <Modal.Header closeButton>
               <Modal.Title style={modalTitleStyle}>
                   <span>
                       <i class="fa fa-trash" aria-hidden="true"> </i> &nbsp;&nbsp;Are you sure you want to Delete this Question?
                   </span>


               </Modal.Title>
           </Modal.Header>
           <ModalBody>
               {/* <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                   <div className="container">
                       <p style={{ fontSize: '16px', fontWeight: '300' }}>Are you sure you want to Delete this Answer?</p>
                       <p style={{ fontSize: '14px', fontWeight: '300' }}>The Seeker will no longer be able to view this answer</p>


                       {!isLoading && <div>
                           <button className="cancelBtn" onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;<button className="rerouteBtn" onClick={() => onClickButtons()}>Yes</button>
                       </div>}
                       {isLoading &&
                           <div>
                               <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting...</button>
                           </div>}
                   </div>
               </div> */}


               <div className="row" style={{ paddingLeft: '3.0rem', paddingRight: '3.0rem', paddingBottom: '5px', textAlign: 'center' }}>
                   <div className="container">
                       <div style={{ width: "100%", justifyContent: "center" }}>
                           <p style={textStyles1}>All of the answers tied to this question will also be deleted.</p>
                           <p style={textStyles1}>And the Seeker will no longer be able to view this question.</p>
                       </div>




                       {!isLoading && <div>
                           <button style={{
                               padding: '8px 12px 8px 12px',
                               borderRadius: '6px',
                               fontSize: '14px',
                               lineHeight: '24px',
                               fontWeight: 400,
                               boxShadow: ' 0px 1px 2px 0px #1018280D',
                               color: '#2A364A',
                               border: '1px solid  #fff',
                               height: '40px',
                               minWidth: '88px',
                               background: " #F6F7F8",
                               marginBottom: '14px',
                               fontWeight: 400,
                               border: " 1px solid #E0E2E6"


                               //  font-weight: 400;          
                           }} onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}>No
                           </button>&nbsp;<button
                               style={{
                                   padding: '8px 12px 8px 12px',
                                   borderRadius: '6px',
                                   fontSize: '14px',
                                   lineHeight: '24px',
                                   fontWeight: 400,
                                   boxShadow: '0px 1px 2px 0px #1018280D',
                                   color: '#FFFFFF',
                                   border: '1px solid  #fff',
                                   height: '40px',
                                   minWidth: '88px',
                                   background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                   marginBottom: '14px',
                                   cursor: "pointer"
                               }}
                               onClick={() => onClickButtons()}>Yes</button>
                       </div>}
                       {isLoading &&
                           <div>
                               <button
                                   style={{
                                       padding: '8px 12px 8px 12px',
                                       borderRadius: '6px',
                                       fontSize: '14px',
                                       lineHeight: '24px',
                                       fontWeight: 400,
                                       boxShadow: '0px 1px 2px 0px #1018280D',
                                       color: '#FFFFFF',
                                       border: '1px solid  #fff',
                                       height: '40px',
                                       minWidth: '88px',
                                       background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                       marginBottom: '14px',
                                       cursor: "not-allowed",
                                       opacity:"0.7"
                                   }}
                                   disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Deleting</button>
                           </div>}
                   </div>
               </div>
           </ModalBody>
       </Modal>
   )
}
